import { Entity } from "../../state/helpers/Entity"
import { PAYMENT_ACCOUNT_STATUS, onboardingApplicationStatusType, paymentAccountStatusType } from "../../utils"
import { OnBoardingApplicationDto } from "./onboardingapplication"

const TEST_SANDBOX_RF_MERCHANT_ID = "sbx_mid_2Wtb2kP0MCBKdKIfuqTVoE9tIRr"
const TEST_PROD_RF_MERCHANT_ID = "mid_2TWvfxvQLMpi0dUa3A9r9ducgsH"

type PaymentAccountAttributes = {
    merchantId: string,
    paymentProcessorKey : string,
    lastOnBoardingApplicationId : string,
    onBoardingApplication : OnBoardingApplicationDto,
    integrationConfigurationId : string,
    status: paymentAccountStatusType,
    feeProfileId : string,
    locationId: string,
    locationIds: string[],
    name:  string,
    activatedAt : string
}

export type PaymentAccountDto = {
    id: string
    attributes: PaymentAccountAttributes
}

export default class PaymentAccount implements Entity {
    private dto: PaymentAccountDto

    constructor(dto: PaymentAccountDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.id != undefined
    }

    getId(): string {
        return this.dto.id
    }

    getMerchantId() : string {
        return this.dto.attributes.merchantId
    }

    hasTestSandboxMerchantId() : boolean {
        return this.dto.attributes.merchantId == TEST_SANDBOX_RF_MERCHANT_ID
    }
    hasTestProdMerchantId() : boolean {
        return this.dto.attributes.merchantId == TEST_PROD_RF_MERCHANT_ID
    }

    getOnBoardingApplicationId() : string {
        return this.dto.attributes.onBoardingApplication.attributes.externalId
    }

    getName(): string {
        return this.dto.attributes.name
    }

    getLocationId(): string {
        return this.dto.attributes.locationId
    }

    getLocationIds(): string[] {
        return this.dto.attributes.locationIds
    }

    getOnboardingStatus(): onboardingApplicationStatusType {
        return this.dto.attributes.onBoardingApplication.attributes.status
    }

    getStatus(): paymentAccountStatusType {
        return this.dto.attributes.status
    }

    getIntegrationConfigurationId(): string {
        return this.dto.attributes.integrationConfigurationId
    }

    getActivatedAt() : string {
        return this.dto.attributes.activatedAt
    }

    isActive(): boolean {
        return this.getStatus() === PAYMENT_ACCOUNT_STATUS.ACTIVE
    }
}


// WEBPACK FOOTER //
// ./src/payment-account/model/paymentaccount.ts